/**
 * Inline SVGs, traced from the design document.
 *
 * The dashboard uses lucide-react; the widget deliberately does not. It loads
 * on third-party pages, so every kilobyte is the merchant's, and these six
 * glyphs are the only ones it needs.
 */

const base = (size, extra = {}) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.9,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
  ...extra,
});

export const ChatIcon = ({ size = 24, color = '#fff' }) => (
  <svg {...base(size)} stroke={color}>
    <path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9.2 9.2 0 0 1-3.9-.8L3 20.5l1.5-4.3A8.3 8.3 0 0 1 3.6 11.5a8.4 8.4 0 0 1 9-8.4 8.4 8.4 0 0 1 8.4 8.4z" />
  </svg>
);

export const MinimizeIcon = ({ size = 16 }) => (
  <svg {...base(size, { strokeWidth: 2 })}>
    <path d="M5 12h14" />
  </svg>
);

export const CloseIcon = ({ size = 16 }) => (
  <svg {...base(size, { strokeWidth: 2 })}>
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

export const AlertTriangleIcon = ({ size = 16 }) => (
  <svg {...base(size, { strokeWidth: 2 })}>
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
    <path d="M12 9v4M12 17h.01" />
  </svg>
);

export const AlertCircleIcon = ({ size = 11 }) => (
  <svg {...base(size, { strokeWidth: 2.4 })}>
    <path d="M12 8v5M12 17h.01" />
    <circle cx="12" cy="12" r="9" />
  </svg>
);

export const ClockIcon = ({ size = 15 }) => (
  <svg {...base(size, { strokeWidth: 2 })}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export const SendIcon = ({ size = 14, color = '#fff' }) => (
  <svg {...base(size, { strokeWidth: 2 })} stroke={color}>
    <path d="m22 2-7 20-4-9-9-4 20-7z" />
  </svg>
);

export const PaperclipIcon = ({ size = 16 }) => (
  <svg {...base(size)}>
    <path d="M21.4 11.05 12.25 20.2a5.5 5.5 0 0 1-7.78-7.78l9.2-9.2a3.67 3.67 0 0 1 5.18 5.19l-9.2 9.19a1.83 1.83 0 0 1-2.6-2.6l8.5-8.48" />
  </svg>
);

export const BoltIcon = ({ size = 10 }) => (
  <svg {...base(size, { strokeWidth: 2.4 })}>
    <path d="m13 2-9 12h7l-1 8 9-12h-7l1-8z" />
  </svg>
);

export const DocIcon = ({ size = 12 }) => (
  <svg {...base(size)}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
  </svg>
);

export const ChevronLeftIcon = ({ size = 14 }) => (
  <svg {...base(size, { strokeWidth: 2 })}>
    <path d="m15 18-6-6 6-6" />
  </svg>
);
